import { render, staticRenderFns } from "./GrupoMenuAdmin.vue?vue&type=template&id=4ca5b234&scoped=true"
import script from "./GrupoMenuAdmin.vue?vue&type=script&lang=js"
export * from "./GrupoMenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./GrupoMenuAdmin.vue?vue&type=style&index=0&id=4ca5b234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5b234",
  null
  
)

export default component.exports